<template>
  <CockpitDialog
    title="正在播放"
    @close="$emit('close')"
    width="1000px"
    height="600px"
    top="175px"
    left="500px"
  >
    <tableButtonGroup
      class="mt-10px mb-10px"
      v-model="activeTab"
      :list="tabList"
      @btn-click="currentChange(1)"
    />
    <el-table :data="tableData" :height="`calc(100% - 90px)`" highlight-current-row>
      <el-table-column label="" width="20">
        <template>
          <div class="selected-row"></div>
        </template>
      </el-table-column>
      <el-table-column
        label="设备名称"
        align="center"
        min-width="80"
        prop="tagName"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        label="设备编码"
        min-width="80"
        align="center"
        prop="tagCode"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        label="描述"
        min-width="140"
        align="center"
        prop="description"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        label="报警等级"
        width="80"
        align="center"
        prop="alarmLevelName"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        label="报警时间"
        width="160"
        align="center"
        prop="startTime"
        :formatter="formatDate"
        show-overflow-tooltip
      ></el-table-column>
    </el-table>
    <el-pagination
      class="mt-10px flex justify-center"
      background
      @current-change="currentChange"
      @size-change="sizeChange"
      :current-page="initPagination.pageNum"
      :page-size="initPagination.pageSize"
      layout="total, prev, pager, next"
      :total="initPagination.total"
      :pager-count="5"
    >
    </el-pagination>
  </CockpitDialog>
</template>

<script>
import CockpitDialog from '@/components/cockpit/CockpitDialog'
import tableButtonGroup from '@/components/cockpit/TableButtonGroup'
import { InspectAlarmRecordApi } from '@wiz-api/roam-inspect-management'

const inspectAlarmRecordApi = new InspectAlarmRecordApi()
export default {
  name: 'alarmDialog',
  components: {
    CockpitDialog,
    tableButtonGroup,
  },
  props: {
    inspectPointId: {
      type: String,
    },
  },
  data() {
    return {
      activeTab: 'DCS报警',
      tabList: ['DCS报警', '趋势预测报警'],
      tableData: [],
      tableLoading: false,
      initPagination: {
        pageNum: 1,
        pageSize: 15,
        total: 0,
      },
    }
  },
  methods: {
    formatDate(row, column, cellValue) {
      if (cellValue) return this.dayjs(cellValue).format('YYYY-MM-DD HH:mm:ss')
      return cellValue
    },
    currentChange(val) {
      this.initPagination.pageNum = val
      this.getList()
    },
    sizeChange(val) {
      this.initPagination.pageSize = val
      this.initPagination.pageNum = 1
      this.getList()
    },
    async getList() {
      this.tableLoading = true
      const [err, res] = await inspectAlarmRecordApi.getList({
        inspectPointIds: [this.inspectPointId],
        alarmType: this.activeTab === 'DCS报警' ? 'DCSThresholdAlarmRecord' : 'AlarmRecord',
        skipCount: (this.initPagination.pageNum - 1) * this.initPagination.pageSize,
        maxResultCount: this.initPagination.pageSize,
      })
      if (!err) {
        this.tableData = res.items || []
        this.initPagination.total = res.totalCount
      }
      this.tableLoading = false
    },
  },
  created() {
    this.getList()
  },
}
</script>

<style lang="scss" scoped></style>
